import React from 'react'
import PropTypes from 'prop-types'

import Button from '@components/ui/Button'

const CallUsFooter = ({ toggleModal }) => (
  <div className="t-center">
    <Button onClick={() => toggleModal()}>Close this popup window</Button>
  </div>
)

CallUsFooter.propTypes = {
  toggleModal: PropTypes.func.isRequired,
}

export default CallUsFooter
